(() => {
  if (customElements.get('eb-compare-teaser')) return;

  customElements.define('eb-compare-teaser', class extends HTMLElement {
    connectedCallback() {
      this.bindMobileTabs();
      this.bindCart();
      this.observeReveal();
    }

    /* Mobile rival tabs */
    bindMobileTabs() {
      const tabs = [...this.querySelectorAll('[data-cmp-mtab]')];
      const panels = [...this.querySelectorAll('[data-cmp-mpanel]')];
      if (!tabs.length) return;
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const i = tab.getAttribute('data-cmp-mtab');
          tabs.forEach((t) => t.classList.toggle('is-on', t === tab));
          panels.forEach((p) => p.classList.toggle('is-on', p.getAttribute('data-cmp-mpanel') === i));
        });
      });
    }

    /* Add to cart — reuses the theme cart event the full comparison uses */
    bindCart() {
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-add-cart]');
        if (!btn) return;
        event.preventDefault();
        this.addToCart(btn.dataset.addCart, btn);
      });
    }

    async addToCart(variantId, btn) {
      const original = btn.textContent;
      btn.disabled = true;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        }).then((r) => { if (!r.ok) throw r; return r.json(); });
        this.dispatchEvent(new CustomEvent('eb:cart:add', {
          bubbles: true, composed: true,
          detail: { lines: [{ id: Number(variantId), quantity: 1 }] },
        }));
      } catch (e) {
        // silent fail; button restores below
      } finally {
        btn.disabled = false;
        btn.textContent = original;
      }
    }

    observeReveal() {
      if (!('IntersectionObserver' in window)) { this.classList.add('is-revealed'); return; }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) { this.classList.add('is-revealed'); io.disconnect(); }
        });
      }, { threshold: 0.12 });
      io.observe(this);
    }
  });
})();
